<div class="col-md-12 container" #scrollableDiv>
  @if (showTopButton) { @if (isGoUpButtonHovered) {
  <button
    mat-fab
    extended
    @buttonAnimation
    (mouseenter)="mouseEvent($event, scrollButton.BUTTON_UP)"
    (mouseleave)="mouseEvent($event, scrollButton.BUTTON_UP)"
    class="go-to-top rounded-full transition-transform duration-200"
    [style.bottom]="upBtnPosition"
    (click)="scrollToTop()"
  >
    <mat-icon style="font-size: 20px">arrow_upward</mat-icon> Subir
  </button>
  } @else {
  <button
    mat-icon-button
    @buttonAnimation
    (mouseenter)="mouseEvent($event, scrollButton.BUTTON_UP)"
    (mouseleave)="mouseEvent($event, scrollButton.BUTTON_UP)"
    class="go-to-top rounded-full transition-transform duration-200"
    [style.bottom]="upBtnPosition"
    (click)="scrollToTop()"
  >
    <mat-icon style="font-size: 20px">arrow_upward</mat-icon>
  </button>
  } } @if (showBottomButton) { @if (isGoDownButtonHovered){
  <button
    mat-fab
    extended
    @buttonAnimation
    class="go-to-bottom rounded-full transition-transform duration-200"
    [style.top]="downBtnPosition"
    (click)="scrollToBottom()"
    (mouseenter)="mouseEvent($event, scrollButton.BUTTON_DOWN)"
    (mouseleave)="mouseEvent($event, scrollButton.BUTTON_DOWN)"
  >
    <mat-icon style="font-size: 20px">arrow_downward</mat-icon> Bajar
  </button>
  } @else {
  <button
    mat-icon-button
    @buttonAnimation
    class="go-to-bottom rounded-full"
    [style.top]="downBtnPosition"
    (click)="scrollToBottom()"
    (mouseenter)="mouseEvent($event, scrollButton.BUTTON_DOWN)"
    (mouseleave)="mouseEvent($event, scrollButton.BUTTON_DOWN)"
  >
    <mat-icon style="font-size: 20px">arrow_downward</mat-icon>
  </button>
  } }
  <div #headerHeight>
    <soph-header-sophia />
  </div>

  <div class="row" #navHeight>
    <div class="container1">
      <div class="column left">
        <img src="assets/icons/arrow_back.svg" />
        <a routerLink="/calendario">Volver a Tu Agenda</a>
      </div>
      <div class="column right">
        <div class="col-md-4 tipo-perfil">
          <img src="assets/icons/info_ficha.svg" alt="" />
          <p class="texto-info" style="margin-bottom: 0">Estás como {{ this.rol() }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row" #infoHeight>
    <div class="container2">
      <div class="column left">
        <div>
          <button mat-fab extended (click)="irAregistro()">
            <div style="display: flex; gap: 8px">
              <img src="assets/icons/white-calendar.svg" />
              <p class="style-button-nueva-consulta">Nueva consulta</p>
              <img src="assets/icons/arrow.svg" />
            </div>
          </button>
        </div>
      </div>
      <div class="column center">
        <h1 style="margin: 0; margin-left: 15px">Ficha Clínica</h1>

        @if(enableAI){
        <button
          class="ai-btn"
          mat-button
          matTooltip="Consultar asistente virtual"
          (click)="openSophiaAgentAI()"
        >
          <mat-icon>medical_information</mat-icon>
          <span>SophIA</span>
        </button>
        }
      </div>
      <div class="column right">
        <div class="col-md-4 estilos-fecha-hora" style="width: 100%; justify-content: flex-end">
          <img src="assets/icons/calendar_ficha.svg" alt="" />
          <p class="style-fecha-hora">{{ fechaNuevaConsulta | date : 'dd/MM/yyyy' }}</p>
          <img src="assets/icons/clock_ficha.svg" alt="" />
          <p class="style-fecha-hora">{{ horaNuevaConsulta }}</p>
        </div>
      </div>
    </div>

    <div class="column right">
      <div
        class="chip-tipo-consulta"
        [ngClass]="{
          presencial: tipoAtencion === presencial,
          telemedicina: tipoAtencion === telemedicina,
          domiciliaria: tipoAtencion === domiciliaria
        }"
      >
        <div>
          <img
            src="assets/icons/house.svg"
            style="display: table-cell"
            *ngIf="tipoAtencion === domiciliaria"
            alt="house"
          />
        </div>
        <div>
          <img
            src="assets/icons/hospital.svg"
            style="display: table-cell"
            *ngIf="tipoAtencion === presencial"
            alt="hospital"
          />
        </div>
        <div>
          <img
            src="assets/icons/telemedicina.svg"
            style="display: table-cell"
            *ngIf="tipoAtencion === telemedicina"
            alt="telemedicina"
          />
        </div>
        <p style="margin-bottom: 0">{{ tipoAtencion }}</p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="Layaout-general">
      <div class="column-layaout left-layout">
        <soph-menu-lateral-info
          [nombrePaciente]="nombrePaciente"
          [apellidosPaciente]="apellidosPaciente"
          [previsionPaciente]="previsionPaciente"
          [correoPaciente]="correoPaciente"
          [telefonoPaciente]="telefonoPaciente"
          [tipoDocumentoPaciente]="tipoDocumentoPaciente"
          [valueTipoDocumentoPaciente]="valueTipoDocumentoPaciente"
          (hasToSetAnamnesis)="handleSetAnamnesis($event)"
        ></soph-menu-lateral-info>
      </div>
      <div class="column-layaout right-layout">
        @if (mostrarTabsFijos) {
        <div class="floating-tab-bar" #floatingTabBar>
          @for ( tab of tabs; let idx = $index; track tab.component ) {
          <button
            [sophHasAccess]="tab.permissions"
            [class.active]="idx === selectedTabIndex()"
            (click)="selectedTabIndex.set(idx)"
          >
            <div class="custom-tab">
              <mat-icon
                [svgIcon]="[tab1, tab2, tab3, tab4, tab5][idx].formReady() ? 'check' : 'alert'"
                [class]="
                  'tab-icon ' +
                  ([tab1, tab2, tab3, tab4, tab5][idx].formReady() ? 'check' : 'alert')
                "
              ></mat-icon>
              <div class="tab-text">
                <span>{{ tab.label }}</span>
                <span>
                  {{
                    [tab1, tab2, tab3, tab4, tab5][idx].formReady()
                      ? 'Completado'
                      : 'Faltan campos requeridos'
                  }}
                </span>
              </div>
            </div>
          </button>
          }
        </div>
        }
        <div #seguimientoDiv></div>

        <mat-tab-group
          (selectedTabChange)="onSelectedTabChange($event)"
          [selectedIndex]="selectedTabIndex()"
        >
          <mat-tab [sophHasAccess]="[AppPermissions.SEE_IDENTIFICATION]">
            <ng-template mat-tab-label>
              <div class="custom-tab">
                <mat-icon
                  [svgIcon]="tab1.formReady() ? 'check' : 'alert'"
                  [class]="'tab-icon ' + (tab1.formReady() ? 'check' : 'alert')"
                ></mat-icon>
                <div class="tab-text">
                  <span>Identificación</span>
                  <span>
                    {{ tab1.formReady() ? 'Completado' : 'Faltan campos requeridos' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <soph-registro #tab1></soph-registro>
          </mat-tab>

          <mat-tab [sophHasAccess]="[AppPermissions.SEE_ANAMNESIS]">
            <ng-template mat-tab-label>
              <div class="custom-tab">
                <mat-icon
                  [svgIcon]="tab2.formReady() ? 'check' : 'alert'"
                  [class]="'tab-icon ' + (tab2.formReady() ? 'check' : 'alert')"
                ></mat-icon>
                <div class="tab-text">
                  <span>Anamnesis</span>
                  <span>
                    {{ tab2.formReady() ? 'Completado' : 'Faltan campos requeridos' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <soph-anamnesis #tab2></soph-anamnesis>
          </mat-tab>

          <mat-tab [sophHasAccess]="[AppPermissions.SEE_DIAGNOSIS]">
            <ng-template mat-tab-label>
              <div class="custom-tab">
                <mat-icon
                  [svgIcon]="tab3.formReady() ? 'check' : 'alert'"
                  [class]="'tab-icon ' + (tab3.formReady() ? 'check' : 'alert')"
                ></mat-icon>
                <div class="tab-text">
                  <span>Diagnóstico</span>
                  <span>
                    {{ tab3.formReady() ? 'Completado' : 'Faltan campos requeridos' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <soph-diagnostico #tab3></soph-diagnostico>
          </mat-tab>

          <mat-tab [sophHasAccess]="[AppPermissions.SEE_TREATMENT]">
            <ng-template mat-tab-label>
              <div class="custom-tab">
                <mat-icon
                  [svgIcon]="tab4.formReady() ? 'check' : 'alert'"
                  [class]="'tab-icon ' + (tab4.formReady() ? 'check' : 'alert')"
                ></mat-icon>
                <div class="tab-text">
                  <span>Tratamiento</span>
                  <span>
                    {{ tab4.formReady() ? 'Completado' : 'Faltan campos requeridos' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <soph-tratamiento #tab4></soph-tratamiento>
          </mat-tab>

          <mat-tab [sophHasAccess]="[AppPermissions.SEE_EXAMS]">
            <ng-template mat-tab-label>
              <div class="custom-tab">
                <mat-icon
                  [svgIcon]="tab5.formReady() ? 'check' : 'alert'"
                  [class]="'tab-icon ' + (tab5.formReady() ? 'check' : 'alert')"
                ></mat-icon>
                <div class="tab-text">
                  <span>Exámenes</span>
                  <span>
                    {{ tab5.formReady() ? 'Completado' : 'Faltan campos requeridos' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <soph-examenes #tab5></soph-examenes>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
